import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox, FormControlLabel, RadioGroup } from '@material-ui/core'

const MultipleChoiceOptions = (props) => {
	//objects
	const { question, checklistResponse } = props
	//Functions
	const { onChecklistResponse } = props
	//bool props
	const { canBeAddedResponse } = props
	let existResponseQuestionResponse = checklistResponse && checklistResponse.QuestionResponses.find((x) => x.Question.Token === question.Token)

	return (
		<RadioGroup>
			{question.Options.map((option, optionIndex) => {
				let existResponse =
					existResponseQuestionResponse &&
					existResponseQuestionResponse.SelectedOptions &&
					existResponseQuestionResponse.SelectedOptions.find((x) => x.Token === option.Token)

				return (
					<div
						key={optionIndex}
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							// marginBottom: '8px',
							// backgroundColor: canBeEditData && option.IsCorrect ? '#D6EAF8' : 'transparent', // Fondo normal para incorrectas
							paddingLeft: '8px', // Espaciado interno opcional
							paddingRight: '8px', // Espaciado interno opcional
							borderRadius: '4px' // Bordes redondeados opcionales
						}}
					>
						<FormControlLabel
							style={{ '& .MuiTypography-root': { fontSize: '12px' } }}
							value={option.Title}
							control={<Checkbox disabled={!canBeAddedResponse} color='primary' checked={existResponse ? true : false} />}
							label={option.Title}
							disabled={!canBeAddedResponse}
							onClick={(event) => onChecklistResponse(question.Token, '', option.Token)}
						/>
					</div>
				)
			})}
		</RadioGroup>
	)
}

MultipleChoiceOptions.propTypes = {
	serie: PropTypes.shape({
		Serie: PropTypes.string,
		Model: PropTypes.string
	}),
	onSave: PropTypes.func.isRequired
}

export default MultipleChoiceOptions
